import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccCheckoutAdapter } from '@spartacus/checkout/base/occ';
import { Observable } from 'rxjs';
import { CustomUnavailableProductsAdapter } from '../connectors';

@Injectable()
export class CustomOccUnavailableProductsAdapter extends OccCheckoutAdapter implements CustomUnavailableProductsAdapter {

  public unavailableProducts(
    userId: string,
    cartId: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.occEndpoints.buildUrl('unavailableProducts', { urlParams: { userId, cartId } });
    return this.http.get(url, { headers });
  }
}
